module.exports = __webpack_public_path__ + "static/img/fullweb.77a42cf2.webp";